import {
  FETCH_PRODUCT_CARE_REQUEST,
  FETCH_PRODUCT_CARE_SUCCESS,
  FETCH_PRODUCT_CARE_FAILURE
} from '../../actionTypes/productCareActionTypes'

const fetchProductCareRequest = (payload, baseUrl) => ({
  type: FETCH_PRODUCT_CARE_REQUEST,
  payload,
  baseUrl
})

const fetchProductCareSuccess = payload => ({
  type: FETCH_PRODUCT_CARE_SUCCESS,
  payload
})

const fetchProductCareFailure = payload => ({
  type: FETCH_PRODUCT_CARE_FAILURE,
  payload
})

export { fetchProductCareRequest, fetchProductCareSuccess, fetchProductCareFailure }
